// extracted by mini-css-extract-plugin
export default {"headerContainer":"Error_headerContainer__9Hopf","errorIcon":"Error_errorIcon__8fgvs","title":"Error_title__AdX8r"};